/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Input, Col, Modal, Row, Skeleton, Table, Tooltip, Typography } from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { deleteAdminSpare } from '../../redux/admin/sparesAdmin/action';
import { Button as CrcButton } from '@crc-evans/ui-components';
const { Text } = Typography;

const SparesList = (props) => {
  const {
    setOpenModel,
    equipTypeList,
    sparesAdminList,
    adminEquipTypesLoading,
    spareTypeForm,
    isSparesListLoading,
    setCurrency,
    setEditSpareId,
    onGetFetchSparesAdminList,
    sparesDataCount,

    setEditModelValue,
    setEditRecord,
    onDeleteAdminSpare,
    isEquipTypeDeleteLoading,
    equipTypeSearchForm,
  } = props;

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteEquipId, setDeleteEquipId] = useState('');
  const [current, setCurrent] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(20);
  //
  const [equipmentType, setEquipmentType] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [sapSparesKitNumber, setSapSparesKitNumber] = useState('');
  const [partSapNumber, setPartSapNumber] = useState('');
  const [description, setDescription] = useState('');
  const [sparesKitQty, setSparesKitQty] = useState('');
  const [safetyStock, setSafetyStock] = useState('');
  const [unitCost, setCost] = useState('');

  const renderColumnTitle = (title, dataIndex, setter, searchKey) => (
    <div className="column-header-with-filter">
      <div className="column-header-text-wrapper">
        <span>{title}</span>
      </div>
      <div className="header-filter-input">
        <Input
          placeholder="Search"
          onChange={(e) => {
            const value = e.target.value;
            setter(value);
            onGetFetchSparesAdminList({ [searchKey]: value });
          }}
          allowClear
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  );

  const typesListColumns = [
    {
      title: 'S.No',
      dataIndex: 'serialNo',
      key: 'serialNo',
      align: 'center',
      width: 80,
      render: (text, record, index) => (current - 1) * currentPagesize + index + 1,
    },
    {
      title: renderColumnTitle('EQUIPMENT TYPE', 'equipmentType', setEquipmentType, 'equipmentType'),
      dataIndex: 'equipmentType',
      key: 'equipmentType',
      align: 'left',
      width: 250,
      sorter: (a, b) => a.equipmentType.localeCompare(b.equipmentType),
    },
    {
      title: renderColumnTitle('SUB CATEGORY', 'subCategory', setSubCategory, 'subCategory'),
      dataIndex: 'subCategory',
      key: 'subCategory',
      align: 'left',
      width: 200,
      sorter: (a, b) => a.subCategory.localeCompare(b.subCategory),
    },
    {
      title: renderColumnTitle('SAP KIT NO', 'sapSparesKitNumber', setSapSparesKitNumber, 'sapSparesKitNumber'),
      dataIndex: 'sapSparesKitNumber',
      key: 'sapSparesKitNumber',
      align: 'left',
      width: 150,
      sorter: (a, b) => a.sapSparesKitNumber.localeCompare(b.sapSparesKitNumber),
    },
    {
      title: renderColumnTitle('SAP NUMBER', 'partSapNumber', setPartSapNumber, 'partSapNumber'),
      dataIndex: 'partSapNumber',
      key: 'partSapNumber',
      align: 'left',
      width: 150,
      sorter: (a, b) => (a.partSapNumber || '').localeCompare(b.partSapNumber || ''),
    },
    {
      title: renderColumnTitle('DESCRIPTION', 'description', setDescription, 'description'),
      dataIndex: 'description',
      key: 'description',
      align: 'left',
      width: 300,
      sorter: (a, b) => a.description.localeCompare(b.description),
      render: (text) => (
        <div className="description-cell">
          {text && text.length > 50 ? text.slice(0, 50) + '...' : text}
        </div>
      ),
    },
    {
      title: renderColumnTitle('SPARES KIT QTY', 'sparesKitQty', setSparesKitQty, 'sparesKitQty'),
      dataIndex: 'sparesKitQty',
      key: 'sparesKitQty',
      align: 'center',
      width: 150,
      sorter: (a, b) => a.sparesKitQty - b.sparesKitQty,
    },
    {
      title: renderColumnTitle('SAFETY STOCK', 'safteyStock', setSafetyStock, 'safteyStock'),
      dataIndex: 'safteyStock',
      key: 'safteyStock',
      align: 'center',
      width: 150,
      sorter: (a, b) => String(a.safteyStock).localeCompare(String(b.safteyStock)),
      render: (text) => <div style={{ textAlign: 'center' }}>{text}</div>,
    },
    {
      title: renderColumnTitle('UNIT COST', 'unitCost', setCost, 'unitCost'),
      dataIndex: 'unitCost',
      key: 'unitCost',
      align: 'left',
      width: 150,
      sorter: (a, b) => a.unitCost.localeCompare(b.unitCost),
      render: (text, record) => (
        <div className="description-cell">
          {record.currency == 'dollar' ? '$' : record.currency == 'pound' ? '£' : '€'} {text}
        </div>
      ),
    },
    {
      title: 'TOTAL COST',
      dataIndex: 'totalCost',
      key: 'totalCost',
      align: 'center',
      width: 150,
      render: (text, record) => {
        const unitCost = record.unitCost;
        const quantity = record.sparesKitQty;
        const totalCost = (unitCost || 0) * (quantity || 0);
        const totalCostRounded = totalCost.toFixed(2);
        return (
          <span>
            {record.currency == 'dollar' ? '$' : record.currency == 'pound' ? '£' : '€'}{' '}
            {totalCostRounded}
          </span>
        );
      },
    },
    {
      title: 'ACTIONS',
      key: 'action',
      dataIndex: 'action',
      align: 'center',
      width: 130,
      fixed: 'right',
      render: (text, record) => {
        return (
          <div className="heat-profile-actions-cell">
            <Tooltip
              title="Update"
              placement="left"
            >
              <EditOutlined
                className="txtIcon"
                style={{ color: '#00A86B', marginRight: '8px' }}
                onClick={() => setEditModel(record)}
              />
            </Tooltip>
            <Tooltip
              title="Delete"
              placement="top"
            >
              <DeleteOutlined
                className="txtIcon"
                style={{ color: '#ef314c' }}
                onClick={() => {
                  setDeleteModal(true);
                  setDeleteEquipId(record);
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];
  /** Setting values for updating equipment types */
  const setEditModel = (record) => {
    setOpenModel(true);
    setEditRecord(record);
    setEditModelValue(true);
    spareTypeForm.setFieldsValue(record);
    setCurrency(record.currency);
    setEditSpareId(record.id);
  };

  /** Resetting values on Closing Modal */
  const handleCancel = () => {
    setDeleteModal(false);
    setDeleteEquipId('');
  };

  /** Waiting to delete equipment type and close Modal */
  useEffect(() => {
    if (!isSparesListLoading) {
      setDeleteModal(false);
      setDeleteEquipId('');
    }
  }, [isSparesListLoading]);

  return (
    <div style={{ background: '#fff' }}>
      <Row gutter={0}>
        <Col
          span={24}
          style={{ padding: '0' }}
        >
          <Table
            className="h-100 pipeline-table heat-profile-table"
            columns={typesListColumns}
            dataSource={sparesAdminList}
            loading={isSparesListLoading}
            pagination={{
              current: current,
              pageSize: currentPagesize,
              total: sparesAdminList.length,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              onChange: (page, size) => {
                setCurrent(page);
                setCurrentPagesize(size);
              },
            }}
            scroll={{ x: 1500 }}
          />
        </Col>
      </Row>
      <Modal
        width={500}
        className="heatprofile-modal"
        title="Delete Spare"
        visible={deleteModal}
        style={{ top: 100 }}
        onCancel={handleCancel}
        footer={[
          <CrcButton
            key="cancel"
            type="secondary"
            onClick={handleCancel}
          >
            Cancel
          </CrcButton>,
          <CrcButton
            key="apply"
            type="primary"
            onClick={() => onDeleteAdminSpare({ id: deleteEquipId.id })}
            loading={isSparesListLoading}
          >
            {isSparesListLoading ? 'Deleting...' : 'Confirm Delete'}
          </CrcButton>,
        ]}
      >
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <Text style={{ fontSize: '16px', color: '#374151' }}>
            Are you sure you want to delete spare?
          </Text>
          <div style={{ marginTop: '12px', fontWeight: 'bold', color: '#ef314c', fontSize: '18px' }}>
            {deleteEquipId && `${deleteEquipId.equipmentType} - ${deleteEquipId.subCategory}`}
          </div>
          <p style={{ marginTop: '16px', color: '#6b7280' }}>
            This action cannot be undone and will remove the spare from the database.
          </p>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ spareAdminReducer }) => {
  const isSparesListLoading = get(spareAdminReducer, 'isFetchsparesAdminDataLoading', []);
  const sparesDataCount = get(spareAdminReducer, 'sparesDataCount', []);
  return {
    isSparesListLoading,
    sparesDataCount,
  };
};

const mapDispatchToProps = {
  onDeleteAdminSpare: deleteAdminSpare,
};

export default connect(mapStateToProps, mapDispatchToProps)(SparesList);
